import type { z } from 'zod';

import { infrastructureQuerySchema } from './infrastructure-query-schema';

export const infrastructureUpdateSchema = infrastructureQuerySchema.pick({
  id: true,
  name: true,
  location: true,
  ip: true,
  notes: true,
});
export type InfrastructureUpdateSchema = z.infer<typeof infrastructureUpdateSchema>;

export const infrastructureCreateSchema = infrastructureUpdateSchema.omit({ id: true });
export type InfrastructureCreateSchema = z.infer<typeof infrastructureCreateSchema>;
